import React from 'react'
import USTemplateDefault from 'src/components/template/us'
import { videos } from 'src/constants/videos'
import { sportIds, leagueIds, teamIds } from 'src/constants/personalizationIds'
import { networkLogos } from 'src/constants'

export default (props) => (
  <USTemplateDefault
    location={props.location}
    lang="en"
    market="us"
    video={videos.texas_rangers.videoUrl}
    staticAnnotation={networkLogos.rangers_sports_network}
    pageTitle="Watch Texas Rangers baseball"
    title={
      <>
        Watch Texas Rangers<sup>®</sup> baseball
      </>
    }
    subtitle="Get live games, local team coverage & more. Regional restrictions apply."
    networkSet="baseball"
    customNetworks={['rangers_sports_network']}
    logo="https://assets-imgx.fubo.tv/marketing/lp/images/partners/logo-lockup-texas-rangers.png?w=450&ch=width&auto=format,compress"
    logoHeight="100px"
    league="MLB"
    sportId={sportIds.Baseball}
    leagueId={leagueIds.MLB}
    teamId={teamIds['Texas Rangers']}
  />
)
